import { ContentHeader } from "./content-header";
import { Translation, t } from "../../../../core/translate";
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { TextEllipsis } from "../../../../components/text-ellipsis";
import Cover from "../../book/cover";
import MediaQueryOverride from "../../../../components/mediaquery/media-query-override";
import {
  styledMedia,
  jsQueries
} from "../../../../components/mediaquery/breakpoints";
import { actions as uiLibraryActions } from "../../../../../redux/ui/library";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import OpenFeaturedBookButton from "../open-featured-book-button";

const InnerContainer = styled.div`
  background-color: ${props => props.theme.color.base.getShade(7)};
  border-radius: 4px;
  padding: 35px 39px 34px 40px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);

  ${styledMedia.medium`
    padding: 24px 40px;
  `}

  ${styledMedia.small`
    padding: 19px 16px;
  `}
`;

const MustReadDescription = styled.div`
  color: white;
  font-size: 1.8rem;
  font-weight: 300;
  line-height: 1.44;
  flex: 1;

  ${styledMedia.medium`
    margin-left: 26px;
  `}

  ${styledMedia.small`
    margin-left: 11px;
    font-size: 1.4rem;
  `}
`;

const CoverButtonContainer = styled.div`
  flex: 1;
`;

const CoverButton = styled.button`
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  transform: scale(1);
  transition: transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);

  &:hover {
    transform: scale(1.05, 1.05);
  }
`;

function MustReadContainer({
  mustReadTitleKey,
  showTopRecommended,
  asset,
  openBookPanel
}) {
  if (!asset || !showTopRecommended) {
    return null;
  }
  const vbid = asset.vbid;
  const description = asset.description || "";
  const descriptionHTML = description.replace(/<[^>]+>/g, "");

  return (
    <div>
      <ContentHeader>
        <Translation id={mustReadTitleKey}>Recommended for you</Translation>
      </ContentHeader>
      <InnerContainer>
        <CoverButtonContainer>
          <CoverButton onClick={openBookPanel}>
            <MediaQueryOverride query={jsQueries.small} width={78}>
              <MediaQueryOverride query={jsQueries.medium} width={156}>
                <Cover
                  isbn={vbid}
                  width={172}
                  borderRadius={4}
                  altText={asset.title || t("library.book-details")}
                  bookTitle={asset.title}
                />
              </MediaQueryOverride>
            </MediaQueryOverride>
          </CoverButton>
        </CoverButtonContainer>
        <MustReadDescription>
          {descriptionHTML ? (
            <MediaQueryOverride query={jsQueries.small} lines={3}>
              <TextEllipsis toolTipText={descriptionHTML} lines={6}>
                <div>{descriptionHTML}</div>
              </TextEllipsis>
            </MediaQueryOverride>
          ) : (
            <Translation id="explore.read-more" />
          )}
          <OpenFeaturedBookButton asset={asset} />
        </MustReadDescription>
      </InnerContainer>
    </div>
  );
}

MustReadContainer.propTypes = {
  asset: PropTypes.shape({
    vbid: PropTypes.string.isRequired,
    description: PropTypes.string
  })
};
const mapStateToProps = (state, props) => ({
  showTopRecommended: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.showTopRecommended",
    true
  ),
  mustReadTitleKey: brandSelectors.getBrandValue(
    state,
    "Subscriptions.TopReads.topRecommendedTitleKey",
    "explore.must-read"
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  openBookPanel: () =>
    dispatch(
      uiLibraryActions.openSimpleBookPanel(props.asset.vbid, props.asset.title)
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(MustReadContainer);
